import { Build, h, Host } from "@stencil/core";
export class Accordion {
    constructor() {
        this.scrollOnChange = false;
        this.useParentForClose = false;
        this.handleClick = (collapse) => {
            this.children.filter(childNode => childNode !== collapse).forEach((childNode) => childNode.setOpen(false));
            if (this.scrollOnChange) {
                const y = this.el.getBoundingClientRect().top + window.scrollY - 120;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        };
    }
    componentDidLoad() {
        if (!Build.isBrowser) {
            return;
        }
        if (this.useParentForClose) {
            this.children = Array.from(this.el.parentNode.querySelectorAll('uvex-collapse'));
        }
        else {
            this.children = Array.from(this.el.querySelectorAll('uvex-collapse'));
        }
        this.children
            .filter(collapse => collapse.querySelector('[collapse-trigger]'))
            .forEach((collapse) => collapse.addEventListener('click', _ => this.handleClick(collapse)));
    }
    render() {
        return (h(Host, { key: '3db4e309d5753fa63a4aa6c94e37c2f891604915' }, h("slot", { key: '2c918aa6b54c7788cfbb8a4a9df583ae77493807' })));
    }
    static get is() { return "uvex-accordion"; }
    static get properties() {
        return {
            "scrollOnChange": {
                "type": "boolean",
                "attribute": "scroll-on-change",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "useParentForClose": {
                "type": "boolean",
                "attribute": "use-parent-for-close",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=accordion.js.map
